import { render, staticRenderFns } from "./QuizMaster.vue?vue&type=template&id=20558eb8&scoped=true&"
import script from "./QuizMaster.vue?vue&type=script&lang=js&"
export * from "./QuizMaster.vue?vue&type=script&lang=js&"
import style0 from "./QuizMaster.vue?vue&type=style&index=0&id=20558eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20558eb8",
  null
  
)

export default component.exports